import ActivityIndicator from './ActivityIndicator'
import { LoadingScreen } from './LoadingScreen'

/** The public discovery journey shares one quiet initial route/language indicator. */
export default function PublicRouteLoading({ pathname }: { pathname: string }) {
    if (!['/', '/classes', '/classes/'].includes(pathname) && !/^\/classes\/[^/]+\/?$/.test(pathname)) return <LoadingScreen />
    return (
        <div data-public-route-loading className="grid min-h-[100svh] place-items-center bg-[var(--dhtn-canvas)]">
            <ActivityIndicator size={32} className="text-[var(--dhtn-text-muted)]" />
        </div>
    )
}
